import { NextPage } from 'next';
import Head from 'next/head';
import styled, { ThemeProvider } from 'styled-components';
import Footer from '../components/BrandSitesV2/common/Footer';
import { BrandSitesV2GlobalStyle, BrandSitesV2Theme } from '../components/BrandSitesV2/common/GlobalStyle';
import Header from '../components/BrandSitesV2/common/Header';
import StickyAppDownloadButton from '../components/BrandSitesV2/common/StickyAppDownloadButton';
import GiftCardSection from '../components/BrandSitesV2/Gift/GiftCardSection';
import GroupGiftSection from '../components/BrandSitesV2/Gift/GroupGiftSection';
import HeroSection from '../components/BrandSitesV2/Gift/HeroSection';
import SendHeartSection from '../components/BrandSitesV2/Gift/SendHeartSection';
import { GoogleAnalyticsBrandsiteScript } from '../components/GoogleAnanlytics';

const GiftPage: NextPage = () => {
  return (
    <>
      <Head>
        <title>청소연구소 - 선물하기</title>
        <meta property="og:title" content="청소연구소 - 선물하기" />
        <meta name="description" content="언제나 좋은, 때가 없는 청소선물" />
        <meta property="og:description" content="언제나 좋은, 때가 없는 청소선물" />
        <meta name="keywords" content="청소연구소,집청소,선물하기,청소선물,부모님선물,기념일선물" />
        <meta name="og:keywords" content="청소연구소,집청소,선물하기,청소선물,부모님선물,기념일선물" />
        <meta property="og:url" content="https://www.cleaninglab.co.kr/gift" />
        <link rel="canonical" href="https://www.cleaninglab.co.kr/gift" />
        <meta
          property="og:image"
          content="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/thumb.png"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="360" />
        <meta property="og:image:type" content="image/png" />
        <GoogleAnalyticsBrandsiteScript />
      </Head>
      <BrandSitesV2GlobalStyle />
      <ThemeProvider theme={BrandSitesV2Theme}>
        <Header textColor="#ffffff" />
        <Main>
          <HeroSection />
          <GiftCardSection />
          <StickyContainer>
            <SendHeartSection />
            <GroupGiftSection />
            <StickyAppDownloadButton />
          </StickyContainer>
        </Main>
        <Footer />
      </ThemeProvider>
    </>
  );
};

export default GiftPage;

const Main = styled.main``;

const StickyContainer = styled.div``;
